module.exports = __webpack_public_path__ + "media/1x1/mk-2413b107.svg";